import * as actions from '../actionTypes'
const initialState = [];

const gradesReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.DELETE_GRADE:
            return state.filter((grade) => grade._id !== action.payload);
        case actions.SET_GRADES:
            return action.payload;
        case actions.ADD_GRADE:
            return [...state, action.payload];
        case actions.UPDATE_GRADE: {
            return state.map((grade) => grade._id === action.payload._id ? action.payload : grade);
        }
        default:
            return state;
    }
};

export default gradesReducer;

